module.exports = __webpack_public_path__ + "static/media/22ESCWA20.67337761.jpg";